var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page page-appeals"},[_c('BreadcrumbsComponent',{attrs:{"title":_vm.currentTitle,"links":_vm.breadcrumbs}}),_c('div',{staticClass:"page__container"},[_c('div',{staticClass:"page__content"},[_c('AsideNavigatorComponent',{attrs:{"routes":_vm.asideLinksWithAppeals}}),_c('RouterView',{key:_vm.$route.fullPath})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }